import AboutUsTrustpilotSection from "./AboutUsTrustpilotSection";

export { AboutUsTrustpilotSection };
